export const __api = ()=>{
    let uri;
    new URL(window.location).hostname === 'localhost' || new URL(window.location).hostname === 'topnotch.demo-4u.com' ? uri ='http://topnotch-dev.us-west-2.elasticbeanstalk.com' : uri ='https://tna.topnotchathletes.com';
    return uri;
} 